/**
 * @generated SignedSource<<2d409d984939e7f722fc537a798854cf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type JwtService = "EDITOR" | "STUDIO" | "UPLOAD" | "%future added value";
export type authJwtQuery$variables = {
  event?: string | null | undefined;
  ocId?: string | null | undefined;
  service: JwtService;
};
export type authJwtQuery$data = {
  readonly jwt: string;
};
export type authJwtQuery = {
  response: authJwtQuery$data;
  variables: authJwtQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "event"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ocId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "service"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "event",
        "variableName": "event"
      },
      {
        "kind": "Variable",
        "name": "opencastId",
        "variableName": "ocId"
      },
      {
        "kind": "Variable",
        "name": "service",
        "variableName": "service"
      }
    ],
    "kind": "ScalarField",
    "name": "jwt",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "authJwtQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "authJwtQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "00290df9a9c343e35e6bac14ac567f77",
    "id": null,
    "metadata": {},
    "name": "authJwtQuery",
    "operationKind": "query",
    "text": "query authJwtQuery(\n  $service: JwtService!\n  $event: ID\n  $ocId: String\n) {\n  jwt(service: $service, event: $event, opencastId: $ocId)\n}\n"
  }
};
})();

(node as any).hash = "7c84f2a0b8448f0cb1f284ca8c3bb281";

export default node;
